import { memo } from "react";

import { DialogModalClose } from "./DialogModalClose";

export const DialogModalHeader = memo(function DialogModalHeader() {
  return (
    <div className="DialogModalHeader">
      <DialogModalClose />
    </div>
  );
});
